import { SidebarTrigger, useSidebar } from '@/components/ui/sidebar/sidebar';

// Below the mobile breakpoint the sidebar becomes an off-canvas sheet, so
// phones need a visible button to open it. On desktop the children render
// exactly as before.
//
// The bar's height is exposed as --mobile-top-bar-height so full-height pages
// (map editors etc.) can size themselves to the space under it, e.g.
// `max-md:h-[calc(100svh-var(--mobile-top-bar-height,0px))]`.
export const MobileTopBar = ({ children }: { children: React.ReactNode }) => {
  const { isMobile } = useSidebar();

  if (!isMobile) return <>{children}</>;

  return (
    <div className="flex flex-col flex-1 min-w-0 min-h-0 [--mobile-top-bar-height:--spacing(12)]">
      <header className="sticky top-0 z-40 flex items-center gap-3 h-(--mobile-top-bar-height) px-4 border-b border-gray-200 bg-white shrink-0">
        <SidebarTrigger className="h-10 w-10" />
        <img src="/logo.png" alt="Zeos" className="h-4 w-auto" />
      </header>
      {children}
    </div>
  );
};
